<template>
  <div class="download-area" @click="stop">
    <div class="content">
      <h2 style="margin-bottom: 20px;">版本升级</h2>
      <p style="color: #666; line-height: 25px;">AI快销新版本来了，带给您更好的使用体验。</p>
      <p style="color: #666; line-height: 25px;">解决了您使用版本的很多问题，强烈建议您升级后使用。</p>
      <p style="color: #666; line-height: 25px;">当前使用的版本已被我们弃用，给您带来的不便，我们十分抱歉！！</p>
      <a class="download" :href="url" target="_self" type="download">点我立即升级</a>
      <span class="close" @click="close">暂不升级</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    let userAgent = window.navigator.userAgent
    let url;
    if(userAgent.indexOf('Mac OS') !== -1) {
      url = 'http://www.aiboog.com/aikuaixiao-mac.dmg'
    }else {
      url = 'http://www.aiboog.com/aikuaixiao-win.exe'
    }
    return {
      url
    }
  },
  methods: {
    stop() {

    },
    close() {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>
<style scoped lang="scss">
.download-area {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    color: #333;
    font-size: 15px;
    background-color: #FFF;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 100px;
  }
  .download {
    color:red;
    font-size: 17px;
    display: inline-block;
    margin-top: 10px;
  }
  .close {
    color: #999;
    font-size: 14px;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>